module.exports = __webpack_public_path__ + "static/media/NeuzeitGroConBla.e919073c.ttf";